import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';

import { GLOBAL_QUERY_PARAMS } from 'shared/constants/queryParams.constants';

const IsWebViewContext = React.createContext<boolean>(null);

function getQueryByName(key: string, queryString: string): string {
  const regex = new RegExp(`[?&]${key}=([^&#]*)`);
  const matched = queryString?.match(regex);
  return matched ? matched[1] : '';
}

export const getIsWebView = (queryString: string): boolean => {
  return getQueryByName(GLOBAL_QUERY_PARAMS.isWebView, queryString) === 'true';
};

export const IsWebViewProvider = ({ children }: React.PropsWithChildren) => {
  const router = useRouter();
  const [value] = useState(() => getIsWebView(router.asPath));

  return (
    <IsWebViewContext.Provider value={value}>
      {children}
    </IsWebViewContext.Provider>
  );
};

export function useIsWebView() {
  const context = useContext(IsWebViewContext);
  if (context === undefined) {
    throw new Error('useIsWebView must be used inside IsWebViewProvider');
  }

  return context;
}
